import { PaymentModalityType } from '@/features/companies/types/companies.type'
import BillsList from '@/features/privateCompanies/pages/Bills/List'
import CompanyCardsList from '@/features/privateCompanies/pages/CompanyCards/List'
import EquipmentList from '@/features/privateCompanies/pages/CompanyEquipments/List'
import CompanyGeneralData from '@/features/privateCompanies/pages/CompanyGeneralData/Show'
import GovernmentAllocationList from '@/features/privateCompanies/pages/CompanyGovernmentAllocations/List'
import PriceSurveyList from '@/features/privateCompanies/pages/CompanyPriceSurvey/List'
import UserList from '@/features/privateCompanies/pages/CompanyUsers/List'
import EventList from '@/features/privateCompanies/pages/Events/List'
import FailedConsumptionList from '@/features/privateCompanies/pages/FailedConsumptions/List'
import TotalsList from '@/features/privateCompanies/pages/Totals/List'
import Structure from '@/features/privateCompanies/tabs/structure'
import { ReactFlowProvider } from '@xyflow/react'
import BankingDepositsList from '../pages/BankingDeposits/List'
import TrackerIntegrations from '../pages/CompanyTrackerIntegration/List'
import CompanyPoliticsShow from '../pages/Politics/Show'
import CompanyMaintenanceTab from '../tabs/maintenance'

export const defaultTabs = ({
  companyKind,
  companyPaymentModality,
  companyPriceSurveyMode,
  remainingCredit,
  remainingBalance,
  showMaintenanceTab
}: {
  companyKind?: string
  companyPaymentModality?: PaymentModalityType
  companyPriceSurveyMode?: 'disabled' | 'informational_only' | 'used_as_price_limit'
  remainingCredit?: string
  remainingBalance?: string
  showMaintenanceTab?: boolean
}) => [
    {
      label: 'Dados Gerais',
      value: '',
      body: <CompanyGeneralData />,
    },
    {
      label: 'Estrutura',
      value: 'branches',
      body: (
        <ReactFlowProvider>
          <Structure companyKind={companyKind} />
        </ReactFlowProvider>
      ),
    },
    {
      label: 'Equipamentos',
      value: 'equipments',
      body: <EquipmentList />,
    },
    {
      label: 'Integrações',
      value: 'tracker-integrations',
      body: <TrackerIntegrations />,
    },
    {
      label: 'Cartões',
      value: 'cards',
      body: <CompanyCardsList />,
    },
    {
      label: 'Usuários',
      value: 'users',
      body: <UserList />,
    },
    {
      label: 'Transações',
      value: 'transactions',
      body: <EventList remainingCredit={remainingCredit} remainingBalance={remainingBalance} companyKind={companyKind} />,
    },
    {
      label: 'Transações falhas',
      value: 'failed-transactions',
      body: <FailedConsumptionList />,
    },
    {
      label: 'Totalizadores',
      value: 'totals',
      body: <TotalsList />,
    },
    {
      label: 'Faturas',
      value: 'bills',
      body: <BillsList />,
    },
    {
      label: companyPaymentModality === 'pre_paid' ? 'Empenhos' : 'Cotas',
      value: 'government-allocation',
      body: <GovernmentAllocationList />,
      hidden: companyKind !== 'public_company',
    },
    {
      label: 'Políticas',
      value: 'politics',
      body: <CompanyPoliticsShow />,
    },
    {
      label: 'Pesq. preço',
      value: 'price-survey',
      body: <PriceSurveyList />,
      hidden: companyPriceSurveyMode === 'disabled',
    },
    {
      label: 'Depósitos',
      value: 'banking-deposits',
      body: <BankingDepositsList />,
      hidden: companyKind !== 'private_company',
      operationKlassToCheckPermission: 'Admin::Banking::Deposits::Filter',
    },
    {
      label: 'Manutenções',
      value: 'maintenance',
      body: <CompanyMaintenanceTab />,
      hidden: !showMaintenanceTab
    },
  ]
